import { Link } from "react-router-dom";
import React from "react";
import "./style.scss";
const GastMenu = ({ token, username, isActive, onToggle }) => {
  if (username.bedrijf && username.bedrijf.modules.includes("gastenverbruik")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "medewerker" || token.role === "havenmeester") {
      return (
        <div className="menu-item">
          <div className="menu-link" onClick={onToggle}>
            <span className="menu-icon"><i className="fas fa-user-check"></i></span>
            <span className="menu-text">Verbruiksgegevens</span>
            <span className={`menu-arrow ${isActive ? "rotate" : ""}`}><i className="fas fa-chevron-right"></i></span>
          </div>
          <div className={`menu-sub ${isActive ? "show" : ""}`}>
            <div className="menu-item">
              <Link to="/gastenverbruik/dashboard" className="menu-link">
                <span className="menu-icon"><i className="fas fa-chart-line"></i></span>
                <span className="menu-text">Dashboard</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/gastenverbruik/" className="menu-link">
                <span className="menu-icon"><i className="fa fa-book-open"></i></span>
                <span className="menu-text">Reserveringen</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/gastenverbruik/gasten" className="menu-link">
                <span className="menu-icon"><i className="fa fa-users"></i></span>
                <span className="menu-text">Gasten</span>
              </Link>
            </div>
            {/* {token.role != "havenmeester" && (
              <div className="menu-item">
                <Link to="/gastenverbruik/insert" className="menu-link">
                  <span className="menu-icon"><i className="fa fa-user-plus"></i></span>
                  <span className="menu-text">Reservering Toevoegen</span>
                </Link>
              </div>
            )} */}
            {token.role != "havenmeester" && (
              <div className="menu-item">
                <Link to="/gastenverbruik/gastenprofiel" className="menu-link">
                  <span className="menu-icon"><i className="fa fa-users-gear"></i></span>
                  <span className="menu-text">Gastprofielen</span>
                </Link>
              </div>
            )}
            {token.role != "havenmeester" && (
              <div className="menu-item">
                <Link to="/gastenverbruik/artikelen" className="menu-link">
                  <span className="menu-icon"><i className="fa fa-box"></i></span>
                  <span className="menu-text">Artikelen</span>
                </Link>
              </div>
            )}
            <div className="menu-item">
              <Link to="/gastenverbruik/activityoverview" className="menu-link">
                <span className="menu-icon"><i className="fas fa-history"></i></span>
                <span className="menu-text">Activity Log</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/toegangscontrole" className="menu-link">
                <span className="menu-icon"><i className="fas fa-key"></i></span>
                <span className="menu-text">Toegangscontrole</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/gastenverbruik/elektriciteitsanalyse" className="menu-link">
                <span className="menu-icon"><i className="fas fa-bolt"></i></span>
                <span className="menu-text">Elektriciteitsanalyse</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/gastenverbruik/planning" className="menu-link">
                <span className="menu-icon"><i className="fas fa-calendar-alt"></i></span>
                <span className="menu-text">Planning</span>
              </Link>
            </div>
            {/* <div className="menu-item">
              <Link to="/gastenverbruik/duurzaam" className="menu-link">
                <span className="menu-icon"><i className="fa fa-user-plus"></i></span>
                <span className="menu-text">Duurzaamheid Tips</span>
              </Link>
            </div> */}
          </div>
        </div>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};
export default GastMenu;
